import { FileItem } from '../FileItem/FileItem';
import styles from './FileList.module.css'

export const FileList = ({ files, onRemove }: { files: File[], onRemove: (name: string) => void }) => {
    return (
        <div className={styles.fileListScrollContainer}>
            {files.length === 0 ? (
                <div className={styles.emptyStatePlaceholder}>
                    <span className={styles.emptyFileListText}>No files attached</span>
                </div>
            ) : (
                <div className={styles.fileGrid}>
                    {files.map((file, index) => (
                        <FileItem 
                            key={`${file.name}-${index}`}
                            file={file}
                            onRemove={onRemove}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};